import DefaultLayout from '@/Layouts/DefaultLayout';
import { lazy } from 'react';
import { LoginRoutes } from '@/features/auth/routes/routes';
import { AuthInitializer } from '@/features/auth/guard/authInitializer';
import { BranchesRoutes } from '@/features/branch/routes/routes';
import { SettingRoutes } from '@/features/setting/routes/routes';
import { PermissionsRoutes } from '@/features/permissions/routes/routes';
import { ProductsListRoutes } from '@/features/products/routes/routes';
import { NotificationsRoutes } from '@/features/notifications/routes/routes';
import { PosRoutes } from '@/features/pos/routes/routes';
import { CustomerRoutes } from '@/features/customers/routes/routes';
import { InvoicesRoutes } from '@/features/invoices/routes/routes';
import { SalesRoutes } from '@/features/sales/routes/routes';
import { ProformaInvoicesRoutes } from '@/features/proforma-invoices/routes/routes';
import { SellersRoutes } from '@/features/sellers/routes/routes';
import { PurchaseOrdersRoutes } from '@/features/purchase-orders/routes/routes';
import { ExpensesRoutes } from '@/features/expenses/routes/routes';
import { AccountsGuideRoutes } from '@/features/accounts-guide/routes/routes';
import { CostCentersRoutes } from '@/features/cost-centers/routes/routes';
import { AssetsRoutes } from '@/features/assets/routes/routes';
import { WarehousesRoutes } from '@/features/warehouses/routes/routes';
import { GeneralAccountsSettingsRoutes } from '@/features/general-accounts-settings/routes/routes';
import { ClosedPeriodsRoutes } from '@/features/closed-periods/routes/routes';
import { PeriodBudgetRoutes } from '@/features/period-budget/routes/routes';
import { JournalEntriesRoutes } from '@/features/journal-entries/routes/routes';
import { ReportsRoutes } from '@/features/reports/routes/routes';
import { ProfitReportRoutes } from '@/features/profit-report/routes/routes';
import { SubscriptionsRoutes } from '@/features/subscriptions/routes/routes';


// ----------------------------------------------------------------------

const Home = lazy(() => import('@/core/global-pages/Home'));
const SoonPage = lazy(() => import('@/core/global-pages/SoonPage'));

// ----------------------------------------------------------------------

const appChildren = [
    { index: true, element: <Home /> },
    {
        path: '/coming-soon',
        element: <SoonPage />,
        layout: 'default',
        isAuthReq: true,
    },
    ...PosRoutes,
    ...CustomerRoutes,
    ...InvoicesRoutes,
    ...SalesRoutes,
    ...ProformaInvoicesRoutes,
    ...SellersRoutes,
    ...PurchaseOrdersRoutes,
    ...ExpensesRoutes,
    ...AccountsGuideRoutes,
    ...CostCentersRoutes,
    ...AssetsRoutes,
    ...WarehousesRoutes,
    ...GeneralAccountsSettingsRoutes,
    ...ClosedPeriodsRoutes,
    ...PeriodBudgetRoutes,
    ...JournalEntriesRoutes,
    ...ProfitReportRoutes,
    ...ReportsRoutes,

    ...BranchesRoutes,
    ...SettingRoutes,
    ...PermissionsRoutes,

    ...ProductsListRoutes,

    ...NotificationsRoutes,
    ...SubscriptionsRoutes,
];

// Normalize child paths for language-prefixed parent.
// When nesting under '/:lang', child routes must be relative (no leading '/').
const normalizeChildPaths = (routesArray: any[]): any[] => {
    return routesArray.map((route) => {
        const r = { ...route } as any;
        if (typeof r.path === 'string' && r.path.startsWith('/')) {
            r.path = r.path.replace(/^\//, '');
        }
        if (Array.isArray(r.children) && r.children.length) {
            r.children = normalizeChildPaths(r.children);
        }
        return r;
    });
};

const routes = [
    // language-prefixed routes: /ar/... or /en/...
    {
        path: '/:lang',
        element: (
            <AuthInitializer>
                <DefaultLayout />
            </AuthInitializer>
        ),
        children: normalizeChildPaths(appChildren),
    },

    // root routes (no prefix) - keep existing structure for backward compatibility
    {
        path: '/',
        element: (
            <AuthInitializer>
                <DefaultLayout />
            </AuthInitializer>
        ),
        children: appChildren,
    },

    // login and auth routes (remain at top-level)
    ...LoginRoutes,
];
export { routes };
